import { Modal } from 'antd';
import React from 'react';

const ConfirmDeleteFalseDealsModal = ({ isModalOpen, handleCancel, handleOk }) => {
    return (
        <Modal
            title="Удалить лжесделку"
            open={isModalOpen}
            onCancel={handleCancel}
            onOk={handleOk}
        >
            Вы действительно хотите удалить лжесделку? <br />
            После удаления лжесделка восстановлению не подлежит.
        </Modal>
    );
};

export default ConfirmDeleteFalseDealsModal;
